'use es6';

import enviro from 'self-service-api/core/utilities/enviro';
import PortalIdParser from 'PortalIdParser';
import { stringify } from 'hub-http/helpers/params';
import { buildUrl } from 'hub-http/helpers/url';
import devLogger from 'react-utils/devLogger';
import { SALES_PROFESSIONAL } from 'self-service-api/constants/UpgradeProducts';
import { ADDON_CUSTOM_SSL } from '../../constants/MerchandiseIds';
var pid = PortalIdParser.get();
var suffix = enviro.isProd() ? '' : 'qa';

var baseUrlOptions = function baseUrlOptions() {
  var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'app';
  return {
    protocol: 'https',
    hostname: env + ".hubspot" + suffix + ".com"
  };
};

var formUrlOptions = {
  protocol: 'https',
  hostname: "api.hsforms" + suffix + ".com"
};

var _createExternalUrl = function _createExternalUrl() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isLocal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var urlOptions = Object.assign({}, baseUrlOptions(isLocal ? 'local' : 'app'), {
    path: path,
    query: stringify(query)
  });
  return buildUrl(urlOptions);
};

var _createProductsAndAddonsLink = function _createProductsAndAddonsLink() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 ? arguments[1] : undefined;

  if (params && !params.upgradeSource) {
    devLogger.warn({
      message: "createProductsAndAddonsLink: Expected upgradeSource for path " + path + " but got " + params.upgradeSource,
      key: "createProductsAndAddonsLink: " + path
    });
  }

  var urlOptions = Object.assign({}, baseUrlOptions(), {
    path: "/browse/" + pid + "/" + path,
    query: stringify(params)
  });
  return buildUrl(urlOptions);
};

var _createPricingPageLink = function _createPricingPageLink() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 ? arguments[1] : undefined;

  if (params && !params.upgradeSource) {
    devLogger.warn({
      message: "createPricingPageLink: Expected upgradeSource for path " + path + " but got " + params.upgradeSource,
      key: "createPricingPageLink: " + path
    });
  }

  var urlOptions = Object.assign({}, baseUrlOptions(), {
    path: "/pricing/" + pid + "/" + path,
    query: stringify(params)
  });
  return buildUrl(urlOptions);
};

var redirectRoutes = {
  'landing-pages': "/pages/" + pid + "/manage/landing",
  email: "/email/" + pid + "/manage",
  'marketing-workflows': "/workflows/" + pid,
  'content-strategy': "/content-strategy/" + pid + "/clusters",
  'sales-workflows': "/workflows/" + pid,
  playbooks: "/playbooks/" + pid,
  sequences: "/sequences/" + pid,
  quotes: "/settings/" + pid + "/sales/products",
  tickets: "/contacts/" + pid + "/tickets/list/view/all",
  feedback: "/feedback/" + pid + "/home",
  'knowledge-base': "/knowledge/" + pid + "/insights/dashboard",
  'service-workflows': "/workflows/" + pid,
  meetings: "/meetings/" + pid,
  'user-settings': "/settings/" + pid + "/users?createUserEmail",
  social: "/social/" + pid + "/",
  seo: "/content-strategy/" + pid + "/recommendations",
  forecasting: "/forecasting/" + pid,
  'live-messages-settings': "/live-messages-settings/" + pid
};
export var mapRedirectTargetToRoute = function mapRedirectTargetToRoute(redirectTarget, upgradeProduct) {
  if (redirectRoutes[redirectTarget]) {
    return redirectRoutes[redirectTarget];
  }

  var hub = upgradeProduct.split('-')[0];
  return upgradeProduct === SALES_PROFESSIONAL ? "/getting-started/" + pid : "/reports-dashboard/" + pid + "/" + hub;
};
export var salesPricing = function salesPricing(upgradeSource) {
  return _createPricingPageLink('sales', {
    upgradeSource: upgradeSource
  });
};
export var marketingPricing = function marketingPricing(upgradeSource) {
  return _createPricingPageLink('marketing', {
    upgradeSource: upgradeSource
  });
};
export var servicePricing = function servicePricing(upgradeSource) {
  return _createPricingPageLink('service', {
    upgradeSource: upgradeSource
  });
};
export var starterContacts = function starterContacts() {
  var urlOptions = Object.assign({}, baseUrlOptions(), {
    path: "/pricing/" + pid + "/confirm-contacts?marketing-starter"
  });
  return buildUrl(urlOptions);
};
export var addonReporting = function addonReporting(upgradeSource) {
  return _createProductsAndAddonsLink('upgrade/reporting', {
    upgradeSource: upgradeSource
  });
};
export var addonAds = function addonAds(upgradeSource) {
  return _createProductsAndAddonsLink('upgrade/ads', {
    upgradeSource: upgradeSource
  });
};
export var addonWebsite = function addonWebsite(upgradeSource) {
  return _createProductsAndAddonsLink('compare/website', {
    upgradeSource: upgradeSource
  });
};
export var cmsPricing = function cmsPricing(upgradeSource) {
  return _createPricingPageLink('cms', {
    upgradeSource: upgradeSource
  });
};
export var addonCrm = function addonCrm(upgradeSource) {
  return _createPricingPageLink('crm', {
    upgradeSource: upgradeSource
  });
};
export var addonBrandDomain = function addonBrandDomain(upgradeSource) {
  return _createProductsAndAddonsLink('upgrade/brand-domain', {
    upgradeSource: upgradeSource
  });
};
export var addonDedicatedIp = function addonDedicatedIp(upgradeSource) {
  return _createProductsAndAddonsLink('services/dedicated-ip', {
    upgradeSource: upgradeSource
  });
};
export var addonAdditionalPortalLink = function addonAdditionalPortalLink(upgradeSource) {
  return _createProductsAndAddonsLink('services/add-on-portal', {
    upgradeSource: upgradeSource
  });
};
export var addonTransactionalEmail = function addonTransactionalEmail(upgradeSource) {
  return _createProductsAndAddonsLink('services/transactional-email', {
    upgradeSource: upgradeSource
  });
};
export var checkout = function checkout(orderId, upgradeSource) {
  return _createExternalUrl("/checkout/" + pid + "/purchases/" + orderId + (upgradeSource ? "?upgradeSource=" + upgradeSource : ''));
};
export var getPaidUserManagementUrl = function getPaidUserManagementUrl() {
  return _createExternalUrl("/settings/" + pid + "/users/paid-users");
};
export var serviceDesignatedTechnicalSupport = function serviceDesignatedTechnicalSupport(upgradeSource) {
  return "https://www.hubspot.com/services/consulting/technical?source=" + upgradeSource;
};
export var serviceInPersonTraining = function serviceInPersonTraining(upgradeSource) {
  return "https://www.hubspot.com/services/classroom-training?source=" + upgradeSource;
};
export var serviceStarterKit = function serviceStarterKit(upgradeSource) {
  return _createProductsAndAddonsLink('services/starter-kit', {
    upgradeSource: upgradeSource
  });
};
export var salesProfessionalOnboarding = function salesProfessionalOnboarding(upgradeSource) {
  return _createProductsAndAddonsLink('services/sales-professional-onboarding', {
    upgradeSource: upgradeSource
  });
};
export var serviceProfessionalOnboarding = function serviceProfessionalOnboarding(upgradeSource) {
  return _createProductsAndAddonsLink('services/service-professional-onboarding', {
    upgradeSource: upgradeSource
  });
};
export var inboundConsultingBlock = function inboundConsultingBlock(upgradeSource) {
  return _createProductsAndAddonsLink('services/inbound-consulting-block', {
    upgradeSource: upgradeSource
  });
};
export var technicalConsultingBlock = function technicalConsultingBlock(upgradeSource) {
  return _createProductsAndAddonsLink('services/technical-consulting-block', {
    upgradeSource: upgradeSource
  });
};
export var productsAndAddons = function productsAndAddons() {
  return _createPricingPageLink();
}; // This paywall is where you'd go to upgrade to Partner status

export var partnerProgramPaywall = function partnerProgramPaywall() {
  var urlOptions = Object.assign({}, baseUrlOptions(), {
    path: "/upgrade/" + pid + "/partner-program"
  });
  return buildUrl(urlOptions);
};
export var suite = function suite(upgradeSource) {
  return _createPricingPageLink('products/growth-suite', {
    upgradeSource: upgradeSource
  });
};
export var bundle = function bundle(upgradeSource) {
  return _createPricingPageLink('bundle', {
    upgradeSource: upgradeSource
  });
};
export var addonCustomSsl = function addonCustomSsl(upgradeSource) {
  return _createPricingPageLink('bundle', {
    upgradeSource: upgradeSource,
    selectedAddOns: ADDON_CUSTOM_SSL
  });
};
export var getAccountDashboardUrl = function getAccountDashboardUrl() {
  return _createExternalUrl("/account-and-billing/" + PortalIdParser.get());
};
export var formUrl = function formUrl(_ref) {
  var portalId = _ref.portalId,
      formId = _ref.formId;
  var urlOptions = Object.assign({}, formUrlOptions, {
    path: "/submissions/v3/integration/submit/" + portalId + "/" + formId
  });
  return buildUrl(urlOptions);
};